import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button, Modal } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserList,
  changeStatus,
  changeMRXStatus,
  changeMRXExpiration,
  exportAllDataByType,
} from "../../store/user";
import { RootState } from "../../store";
import { useHistory } from "react-router";
import "./style.css";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import { toast } from "react-toastify";

const MRXUserList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("subscribed(desktop)");
  const { userList, loadingUser, totalCount } = useSelector(
    (state: RootState) => state.user
  );
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [selectedDate, handleDateChange] = useState({
    desktop: null,
    mobile: null,
  });
  const [userId, setUserId] = useState();

  let history = useHistory();
  useEffect(() => {
    getUsers(search, filter, page, rowsPerPage);
  }, [filter]);

  const getUsers = async (search: any, filter: any, page: any, limit: any) => {
    dispatch(
      getUserList({ search: search, filter, page: page + 1, limit: limit })
    );
  };
  const searching = (e: any) => {
    if (e.key === "Enter") {
      getUsers(search, filter, page, rowsPerPage);
    }
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    getUsers(search, filter, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    getUsers(search, filter, 0, event.target.value);
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const edit = async (row: any, option: any) => {
    if (option === "edit") {
      history.push("/user-edit/" + row.user_id);
    } else {
      history.push("/user-view/" + row.user_id);
    }
  };
  const changeRowStatus = async (row: any, option: any) => {
    if (window.confirm("Do you wants to change status ?")) {
      if (option === "approve") {
        dispatch(
          changeMRXStatus({
            data: { active_status_in_project: "Y" },
            id: row.user_id,
          })
        );
      } else {
        dispatch(
          changeMRXStatus({
            data: { active_status_in_project: "N" },
            id: row.user_id,
          })
        );
      }
      toast.success("Status Change successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const OpenSubscriptionModal = (row: any) => {
    setSubscriptionModal(true);
    setUserId(row.user_id);
    handleDateChange({
      desktop: row.bdf_pescription?.membership_expiration_date
        ? row.bdf_pescription.membership_expiration_date
        : null,
      mobile: row.bdf_pescription?.membership_expiration_date_mobile
        ? row.bdf_pescription.membership_expiration_date_mobile
        : null,
      // : new Date()
    });
  };

  const closeSubscriptionModal = () => {
    setSubscriptionModal(false);
  };
  const changeDate = (date: any, type: any) => {
    let lo_date: any = { ...selectedDate };
    lo_date[type] = date;

    handleDateChange(lo_date);
  };
  const changeExpirationDate = () => {
    dispatch(
      changeMRXExpiration({
        data: { membership_expiration_date: selectedDate },
        id: userId,
      })
    );
    toast.success("Subscription Expiration Change successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSubscriptionModal(false);
  };

  const clickHandler = (e: any) => {
    e.preventDefault();
    dispatch(exportAllDataByType(filter)).then((res: any) => {
      if (res?.payload?.data) {
        const { data, ls_fileName } = res.payload.data;

        const url = URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = ls_fileName;
        link.click();
        URL.revokeObjectURL(url);
      }
    });
  };

  const getSubscriptionStatus = (row: any) => {
   
    var subscription_status = "";
    return function (name: any) {
  
      if (row?.bdf_pescription?.[name]) {
        const expiryDate = new Date(row?.bdf_pescription[name]);

        const expiredDateonly =
          expiryDate.getFullYear() +
          "-" +
          (expiryDate.getMonth() + 1) +
          "-" +
          expiryDate.getDate();

        const expiryTimestamp = new Date(expiredDateonly).getTime();
        const todayTimestamp = new Date().getTime();
        let diffTime = expiryTimestamp - todayTimestamp;
        let dateDiff =
          diffTime !== 0 ? Math.ceil(diffTime / (1000 * 60 * 60 * 24)) : 0;
        subscription_status = dateDiff >= 0 ? "Active" : "Expired";
        return subscription_status;
      }
    };
  };

  return (
    <>
      <div className="row align-items-center  mw-100">
        <div className="col-md-10 padded_row">
          {[
            "subscribed(desktop)",
            "subscribed(mobile)",
            "expired(desktop)",
            "expired(mobile)",
            "unsubscribed",
          ].map((tab, index) => (
            <Button
              variant="outlined"
              className={
                tab === filter
                  ? "subscription_btn selected"
                  : "subscription_btn"
              }
              value={tab}
              onClick={(event) => {
                setFilter(event.currentTarget.value.toLowerCase());
                setPage(0);
              }}
            >
              {tab}
            </Button>
          ))}
        </div>

        <div className="col-md-2 text-end">
          {[
            "subscribed(desktop)",
            "subscribed(mobile)",
            "expired(desktop)",
            "expired(mobile)",
          ].includes(filter) && (
            <Button
              variant="contained"
              startIcon={<ArrowDownwardIcon />}
              onClick={(e) => clickHandler(e)}
            >
              Export
            </Button>
          )}
        </div>
      </div>

      <div className="mb-10">
        <input
          className="form-control"
          value={search}
          placeholder="Search "
          onKeyDown={(e) => searching(e)}
          onChange={(event) => setSearch(event.target.value)}
        />
      </div>
      <TableContainer component={Paper}>
        <Table className="table data__table border-0" aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Id</TableCell>
              <TableCell align="center">First Name</TableCell>
              <TableCell align="center">Last Name</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">BDF ID</TableCell>
              <TableCell align="center">BMDC Number</TableCell>
              <TableCell align="center">Mobile Number</TableCell>
              <TableCell align="center">Subscription Status(Desktop)</TableCell>
              <TableCell align="center">Subscription Status(Mobile)</TableCell>
              <TableCell align="center"> Expiration Date(Desktop)</TableCell>
              <TableCell align="center"> Expiration Date(Mobile)</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          {userList.length > 0 && (
            <TableBody>
              {userList.map((row: any, index) => {
                const subscriptionFunc = getSubscriptionStatus(row);
                let ls_desktop_status = subscriptionFunc(
                  "membership_expiration_date"
                );
                let ls_mobile_status = subscriptionFunc(
                  "membership_expiration_date_mobile"
                );

                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row?.user_id}
                    </TableCell>
                    <TableCell align="center">{row?.first_name}</TableCell>
                    <TableCell align="center">{row?.last_name}</TableCell>
                    <TableCell align="center">{row?.email}</TableCell>
                    <TableCell align="center">
                      {row?.bdf_foundation?.bdf_id  ? (
                        <>
                          <p>{row?.bdf_foundation?.bdf_id}</p>
                        </>
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row?.bdf_foundation?.bm_dc_number ? (
                        <>
                          <p>{row?.bdf_foundation?.bm_dc_number}</p>
                        </>
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell align="center">{row?.phone}</TableCell>
                    <TableCell align="center">
                      {row?.bdf_pescription?.membership_expiration_date ? (
                        ls_desktop_status == "Active" ? (
                          <span className="activeStatus">
                            {ls_desktop_status}
                          </span>
                        ) : (
                          <span className="expireStatus">
                            {ls_desktop_status}
                          </span>
                        )
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row?.bdf_pescription
                        ?.membership_expiration_date_mobile ? (
                        ls_mobile_status == "Active" ? (
                          <span className="activeStatus">
                            {ls_mobile_status}
                          </span>
                        ) : (
                          <span className="expireStatus">
                            {ls_mobile_status}
                          </span>
                        )
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    <TableCell align="center">
                      {row?.bdf_pescription?.membership_expiration_date
                        ? moment(
                            row?.bdf_pescription?.membership_expiration_date
                          ).format("DD/MM/YYYY")
                        : "--"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.bdf_pescription?.membership_expiration_date_mobile
                        ? moment(
                            row?.bdf_pescription
                              ?.membership_expiration_date_mobile
                          ).format("DD/MM/YYYY")
                        : "--"}
                    </TableCell>
                    <TableCell align="center">
                      <div className="user-list-action-cell">
                        {row?.bdf_pescription?.active_status_in_project ==
                        "Y" ? (
                          <Button
                            className="btn-sm"
                            variant="contained"
                            color="secondary"
                            onClick={() => changeRowStatus(row, "reject")}
                          >
                            Reject
                          </Button>
                        ) : (
                          <Button
                            className="btn-sm delete-btn"
                            variant="contained"
                            color="primary"
                            onClick={() => changeRowStatus(row, "approve")}
                          >
                            Approve
                          </Button>
                        )}
                        <Button
                          className="btn-sm"
                          variant="contained"
                          color="primary"
                          onClick={() => OpenSubscriptionModal(row)}
                        >
                          Subsription
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {userList.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={Number(totalCount)}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
      <Modal
        open={subscriptionModal}
        onClose={closeSubscriptionModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="card custom-modal">
          <div className="card-header d-flex align-items-center border-bottom ">
            <h2 id="simple-modal-title" className="mb-0">
              Set Subsription End Date
            </h2>

            <button className="btn close_btn" onClick={closeSubscriptionModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="card-body">
            <form onSubmit={changeExpirationDate}>
              <div className="mb-3">
                <label className="form-label">Expiration Date</label>
                <br></br>
                <div className="d-flex w-100 justify-content-between">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      clearable
                      label="For Desktop"
                      value={selectedDate?.desktop}
                      onChange={(date) => changeDate(date, "desktop")}
                      // minDate={new Date()}
                      format="dd/MM/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      clearable
                      value={selectedDate?.mobile}
                      label="For Mobile"
                      onChange={(date) => changeDate(date, "mobile")}
                      // minDate={new Date()}
                      format="dd/MM/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>

              <Button
                className="mt-4"
                variant="contained"
                color="primary"
                type="submit"
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MRXUserList;
